import styles from './HeaderImageCard.module.scss';


const HeaderImageCard = ({element}) => {
    const { src } = element;
    return ( 
    <div className= {styles.container}>
        <img className={styles.photo} src={src} alt='семейная фотосессия Ставрополь'/>
    </div> 
    );
}

export default HeaderImageCard;